
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://lwmwddbuzjrygfoxhagj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx3bXdkZGJ1empyeWdmb3hoYWdqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI3ODE5OTQsImV4cCI6MjA1ODM1Nzk5NH0.aw66JaZUgI5eWeRXtw0S1sHcwg36K66ffAG5BvCD0QI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: localStorage,
    flowType: 'pkce', // Enable PKCE flow for more secure OAuth
  },
});
